@if (storeInfoFacId != 0 && !isFromUnitInfo && !isFromQuickprospect) {
  <div class="head_store_info">
    <a class="storeinfo_toggle warehouse_icon" href="javascript:;" (click)="storetoggClass('open')"> </a>
    <div class="storeinfo_outer">
      <h2>{{facilityInfoDetails?.Name}}</h2>
      <!-- - {{facilityInfoDetails?.Address}} - Phone Number : 1-{{facilityInfoDetails?.PhoneNo | slice:0:3}}-{{facilityInfoDetails?.PhoneNo | slice:3:6}}-{{facilityInfoDetails?.PhoneNo | slice:6:10}} -->
      <div class="store_info_lft">
        <ul class="nav nav-tabs" id="storeTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="info-tab" data-bs-toggle="tab" href="#storeinfo" role="tab"
            aria-controls="info" aria-selected="true" (click)="onClickOfTabs('storeinfo')">Info</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="hours-tab" data-bs-toggle="tab" href="#hours" role="tab"
            aria-controls="hours" aria-selected="true" (click)="onClickOfTabs('hours')">Hours</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="holidays-tab" data-bs-toggle="tab" href="#holidays" role="tab"
            aria-controls="holidays" aria-selected="false" (click)="onClickOfTabs('holidays')">Holidays</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="features-tab" data-bs-toggle="tab" href="#features" role="tab"
            aria-controls="features" aria-selected="false" (click)="onClickOfTabs('features')">Features</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="merchandise-tab" data-bs-toggle="tab" href="#merchandise" role="tab"
            aria-controls="merchandise" aria-selected="false" (click)="onClickOfTabs('merchandise')">Merchandise</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="internet-tab" data-bs-toggle="tab" href="#internet" role="tab"
            aria-controls="internet" aria-selected="false" (click)="onClickOfTabs('internet')">Internet</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="maps-tab" data-bs-toggle="tab" href="#maps" role="tab"
            aria-controls="maps" aria-selected="false" (click)="onClickOfTabs('maps')">Maps</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="Siteinfo-tab" data-bs-toggle="tab" href="#Siteinfo" role="tab"
            aria-controls="Siteinfo" aria-selected="false" (click)="onClickOfTabs('Siteinfo')">Site Info</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="kiosk-tab" data-bs-toggle="tab" href="#kiosk" role="tab"
            aria-controls="kiosk" aria-selected="false" (click)="onClickOfTabs('kiosk')">Kiosk</a>
          </li>
        </ul>
        <div class="tab-content" id="storeTabContent">
          <div class="tab-pane fade show active" id="storeinfo" role="tabpanel"
            aria-labelledby="info-tab">
            <div id="tableScrollable" class=" p-0">
              <div class="infoList">
                <ul>
                  <li><label>Address</label>
                  <p>{{facilityInfoDetails?.Address}}</p>
                </li>
                <li>
                  <label>Zip</label>
                  <p>{{facilityInfoDetails?.Zip}}</p>
                </li>
                <li><label>Phone #</label>
                <p>{{facilityInfoDetails?.CountryId}}{{facilityInfoDetails?.PhoneNo | phone:1}}
                </p>
              </li>
              <li><label>City</label>
              <p>{{facilityInfoDetails?.City}}</p>
            </li>
            <li>
              <label>Country</label>
              <p>{{facilityInfoDetails?.Country}}</p>
            </li>
            <li><label>Email</label>
            <p>{{facilityInfoDetails?.EmailId}}</p>
          </li>
          <li>
            <label>State</label>
            <p>{{facilityInfoDetails?.StateName}}</p>
          </li>
          <li>
            <label>Timezone</label>
            <p>{{facilityInfoDetails?.Timezone}}</p>
          </li>
          <li><label>Fax</label>
          <p>{{facilityInfoDetails?.CountryId}}{{facilityInfoDetails?.Fax  | phone:1}}
          </p>
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="tab-pane fade" id="hours" role="tabpanel" aria-labelledby="hours-tab">
  <div id="tableScrollable" class=" p-0">
    <!-- <div > -->
    <table id="prospectsTable" class="table storeInfoTableHeader table-hover mb-0 ">
      <thead>
        <tr>
          <th>Day</th>
          <th>Store Hours</th>
          <th>Gate Hours</th>
        </tr>
      </thead>
    </table>
    <div class="scrollDiv">
      <table id="prospectsTable" class="table storeInfoTable table-hover mb-0 ">
        @for (item of facilityHours; track item) {
          <tbody>
            <tr>
              <td>{{item.DayName}}</td>
              <td>
                @if (item.StoreOpen) {
                  <span>{{item.StartTime}} to
                  {{item.EndTime}}</span>
                }
                @if (!item.StoreOpen) {
                  <span>Closed</span>
                }
              </td>
              <td>
                @if (item.GateOpen) {
                  <span>{{item.GateStartTime}} to
                  {{item.GateEndTime}}</span>
                }
                @if (!item.GateOpen) {
                  <span>Closed</span>
                }
              </td>
            </tr>
          </tbody>
        }
      </table>
    </div>
  <!-- </div> -->
</div>
</div>
<div class="tab-pane fade" id="holidays" role="tabpanel" aria-labelledby="holidays-tab">
  <div id="tableScrollable" class=" p-0">
    <!-- <div > -->
    <div class="scrollDiv holidaysList">
      <ul>
        @for (item of facilityHolidays; track item) {
          <li>{{item.Name}}
          ({{item.Date | date :'MM/dd/yyyy'}})</li>
        }
      </ul>
    </div>
  <!-- </div> -->
</div>
</div>
<div class="tab-pane fade" id="features" role="tabpanel" aria-labelledby="features-tab">
  <table class="table storeInfoTableHeader table-hover mb-0 ">
    <colgroup>
    <col width="50%">
    <col width="50%">
  </colgroup>
  <thead>
    <tr>
      <th>Amenities</th>
      <th style="padding-left: 11px;">Miscellaneous</th>
    </tr>
  </thead>
</table>
<div class="scrollDiv">
  <table class="table storeInfoTable table-hover mb-0">
    <colgroup>
    <col width="50%">
    <col width="50%">
  </colgroup>
  <tbody>
    <tr>
      <td>
        <ul>
          @for (item of featuresAminities; track item) {
            <li>{{item.Amenity}}</li>
          }
        </ul>
      </td>
      <td>
        <ul>
          @for (item of featuresMisc; track item) {
            <li>{{item.Amenity}}</li>
          }
        </ul>
      </td>
    </tr>
  </tbody>
</table>
</div>
</div>
<div class="tab-pane fade" id="merchandise" role="tabpanel" aria-labelledby="merchandise-tab">
  <div id="tableScrollable" class=" p-0">
    <!-- <div > -->
    <table id="prospectsTable" class="table storeInfoTableHeader table-hover mb-0 ">
      <colgroup>
      <col width="35%">
      <col width="20%">
      <col width="18%">
      <col width="30%">
    </colgroup>
    <thead>
      <tr>
        <th>Item</th>
        <th>Price</th>
        <th style="padding-left: 10px;">In Stock</th>
        <th>
          <div>
            <div class="search_sel_box pe-0">
              <input type="text" id="input1" class="form-control border-right-0" [(ngModel)]="searchmerchandisepack"  (keyup)="onsearchMerch($event.target.value)" >
              @if (searchValue) {
                <button type="button" class="search_close" style="width:10px" (click)="resetfilter()">
                  <span aria-hidden="true">×</span>
                </button>
              }
            </div>
            <button type="button" class="btn btn-primary rounded-0" [disabled]="true" ><i class="fa fa-search"></i></button>
          </div>
        </th>
      </tr>
    </thead>
  </table>
  <div class="scrollDiv">
    <table id="prospectsTable" class="table storeInfoTable table-hover mb-0 ">
      <colgroup>
      <col width="35%">
      <col width="20%">
      <col width="18%">
      <col width="30%">
    </colgroup>
    @for (item of facilityMerchandise; track item) {
      <tbody>
        <tr>
          <td>{{item.Name}}</td>
          <td>{{item.TenantPrice | currency}}</td>
          <td>{{item.Quantity}}</td>
          <td></td>
        </tr>
      </tbody>
    }
  </table>
</div>
<!-- </div> -->
</div>
</div>
<div class="tab-pane fade" id="internet" role="tabpanel" aria-labelledby="internet-tab">
  <p>Website : <span style="color: blue; text-decoration: underline;cursor: pointer;"
  (click)="redirectToUrl()"> {{facilityInternetSettings?.WebsiteUrl}}</span></p>
  <p>Email : {{facilityInfoDetails?.EmailId}}</p>
  <!-- <a href="javascript:;">Site Info</a> -->
</div>
<div class="tab-pane fade" id="maps" role="tabpanel" aria-labelledby="maps-tab">
  <ul>
    <li>
      <label>From</label>
      <div class="inputbox"><input type="text" class="form-control form-control-sm"
      [(ngModel)]="mapFrom" /></div>
    </li>
    <li>
      <label>To</label>
      <div class="inputbox"><input type="text" class="form-control form-control-sm"
      [(ngModel)]="mapTo" /></div>
      <button type="button" class="btn btn-primary btn-sm" (click)="goToMap()"><i
      class="fa fa-search"></i></button>
    </li>
  </ul>
</div>
<div class="tab-pane fade" id="Siteinfo" role="tabpanel" aria-labelledby="Siteinfo-tab">
  <p class="m-0" [innerHTML]="getFormattedSiteInformation(facilityInternetSettings?.SiteInformation)"></p>
</div>
<div class="tab-pane fade" id="kiosk" role="tabpanel" aria-labelledby="kiosk-tab">
  <p class="m-0" [innerHTML]="getFormattedSiteInformation(facilityInternetSettings?.KioskInformation)"></p>
</div>
</div>
</div>
<div class="store_img"><img [src]="photoFilePath" style="height: 185px; width: 185px" alt="store image" /></div>
</div>
</div>
}

<ng-template #template1>
  <div class="modal-content">
    <div class="modal-header">
      <h6 style="color: #fff;">{{facilityInfoDetails?.Name}}</h6>
      <button type="button" class="close pull-right" aria-label="Close" data-bs-dismiss="modal" (click)="closeModal();">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="storeinfo_outer store-unit-info">
        <!-- - {{facilityInfoDetails?.Address}} - Phone Number : 1-{{facilityInfoDetails?.PhoneNo | slice:0:3}}-{{facilityInfoDetails?.PhoneNo | slice:3:6}}-{{facilityInfoDetails?.PhoneNo | slice:6:10}} -->
        <div class="store_info_lft">
          <ul class="nav nav-tabs" id="storeTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="info-tab-unitInfo" data-bs-toggle="tab" href="#storeinfo-unitInfo" role="tab"
              aria-controls="info" aria-selected="true" (click)="onClickOfTabs('storeinfo')">Info</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="hours-tab-unitInfo" data-bs-toggle="tab" href="#hours-unitInfo" role="tab"
              aria-controls="hours" aria-selected="true" (click)="onClickOfTabs('hours')">Hours</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="holidays-tab-unitInfo" data-bs-toggle="tab" href="#holidays-unitInfo" role="tab"
              aria-controls="holidays" aria-selected="false" (click)="onClickOfTabs('holidays')">Holidays</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="features-tab-unitInfo" data-bs-toggle="tab" href="#features-unitInfo" role="tab"
              aria-controls="features" aria-selected="false" (click)="onClickOfTabs('features')">Features</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="merchandise-tab-unitInfo" data-bs-toggle="tab" href="#merchandise-unitInfo" role="tab"
              aria-controls="merchandise" aria-selected="false" (click)="onClickOfTabs('merchandise')">Merchandise</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="internet-tab-unitInfo" data-bs-toggle="tab" href="#internet-unitInfo" role="tab"
              aria-controls="internet" aria-selected="false" (click)="onClickOfTabs('internet')">Internet</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="maps-tab-unitInfo" data-bs-toggle="tab" href="#maps-unitInfo" role="tab"
              aria-controls="maps" aria-selected="false" (click)="onClickOfTabs('maps')">Maps</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="Siteinfo-tab-unitInfo" data-bs-toggle="tab" href="#Siteinfo-unitInfo" role="tab"
              aria-controls="Siteinfo" aria-selected="false" (click)="onClickOfTabs('Siteinfo')">Site Info</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="kiosk-tab-unitInfo" data-bs-toggle="tab" href="#kiosk-unitInfo" role="tab"
              aria-controls="kiosk" aria-selected="false" (click)="onClickOfTabs('kiosk')">Kiosk</a>
            </li>
          </ul>
          <div class="tab-content" id="storeTabContent">
            <div class="tab-pane fade show active" id="storeinfo-unitInfo" role="tabpanel"
              aria-labelledby="info-tab-unitInfo">
              <div id="tableScrollable" class=" p-0">
                <div class="infoList">
                  <ul>
                    <li><label>Address</label>
                    <p>{{facilityInfoDetails?.Address}}</p>
                  </li>
                  <li>
                    <label>Zip</label>
                    <p>{{facilityInfoDetails?.Zip}}</p>
                  </li>
                  <li><label>Phone #</label>
                  <p>{{facilityInfoDetails?.CountryId}}{{facilityInfoDetails?.PhoneNo | phone:1}}
                  </p>
                </li>
                <li><label>City</label>
                <p>{{facilityInfoDetails?.City}}</p>
              </li>
              <li>
                <label>Country</label>
                <p>{{facilityInfoDetails?.Country}}</p>
              </li>
              <li><label>Email</label>
              <p>{{facilityInfoDetails?.EmailId}}</p>
            </li>
            <li>
              <label>State</label>
              <p>{{facilityInfoDetails?.StateName}}</p>
            </li>
            <li>
              <label>Timezone</label>
              <p>{{facilityInfoDetails?.Timezone}}</p>
            </li>
            <li><label>Fax</label>
            <p>{{facilityInfoDetails?.CountryId}}{{facilityInfoDetails?.Fax  | phone:1}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="tab-pane fade" id="hours-unitInfo" role="tabpanel" aria-labelledby="hours-tab-unitInfo">
    <div id="tableScrollable" class=" p-0">
      <!-- <div > -->
      <table id="prospectsTable" class="table storeInfoTableHeader table-hover mb-0 ">
        <thead>
          <tr>
            <th>Day</th>
            <th>Store Hours</th>
            <th>Gate Hours</th>
          </tr>
        </thead>



      </table>

      <div class="scrollDiv">
        <table id="prospectsTable" class="table storeInfoTable table-hover mb-0 ">

          @for (item of facilityHours; track item) {
            <tbody>
              <tr>
                <td>{{item.DayName}}</td>
                <td>
                  @if (item.StoreOpen) {
                    <span>{{item.StartTime}} to
                    {{item.EndTime}}</span>
                  }
                  @if (!item.StoreOpen) {
                    <span>Closed</span>
                  }
                </td>
                <td>
                  @if (item.GateOpen) {
                    <span>{{item.GateStartTime}} to
                    {{item.GateEndTime}}</span>
                  }
                  @if (!item.GateOpen) {
                    <span>Closed</span>
                  }
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
    <!-- </div> -->
  </div>
</div>
<div class="tab-pane fade" id="holidays-unitInfo" role="tabpanel" aria-labelledby="holidays-tab-unitInfo">
  <div id="tableScrollable" class=" p-0">
    <!-- <div > -->

    <div class="scrollDiv holidaysList">
      <ul>
        @for (item of facilityHolidays; track item) {
          <li>{{item.Name}}
          ({{item.Date | date :'MM/dd/yyyy'}})</li>
        }
      </ul>
    </div>
  <!-- </div> -->
</div>
</div>
<div class="tab-pane fade" id="features-unitInfo" role="tabpanel" aria-labelledby="features-tab-unitInfo">
  <div id="tableScrollable" class=" p-0">
    <table class="table storeInfoTableHeader table-hover mb-0 ">
      <colgroup>
      <col width="50%">
      <col width="50%">
    </colgroup>
    <thead>
      <tr>
        <th>Amenities</th>
        <th style="padding-left: 11px;">Miscellaneous</th>
      </tr>
    </thead>
  </table>

  <div class="scrollDiv">
    <table class="table storeInfoTable table-hover mb-0">
      <colgroup>
      <col width="50%">
      <col width="50%">
    </colgroup>
    <tbody>
      <tr>
        <td>
          <ul>
            @for (item of featuresAminities; track item) {
              <li>{{item.Amenity}}</li>
            }
          </ul>
        </td>
        <td>
          <ul>
            @for (item of featuresMisc; track item) {
              <li>{{item.Amenity}}</li>
            }
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
</div>
</div>
</div>
<div class="tab-pane fade" id="merchandise-unitInfo" role="tabpanel" aria-labelledby="merchandise-tab-unitInfo">
  <div id="tableScrollable" class=" p-0">
    <!-- <div > -->
    <table class="table storeInfoTableHeader table-hover mb-0 ">
      <colgroup>
      <col width="40%">
      <col width="20%">
      <col width="13%">
      <col width="30%">
    </colgroup>
    <thead>
      <tr>
        <th>Item</th>
        <th>Price</th>
        <th>In Stock</th>
        <th>
          <div>
            <div class="search_sel_box pe-0">
              <input type="text" (focusin)="$event.stopPropagation()" id="input1" class="form-control border-right-0" [(ngModel)]="searchmerchandisepack"  (keyup)="onsearchMerch($event.target.value)" >
              @if (searchValue) {
                <button type="button" class="search_close" style="width:10px" (click)="resetfilter()">
                  <span aria-hidden="true">×</span>
                </button>
              }
            </div>
            <button type="button" class="btn btn-primary rounded-0" [disabled]="true" ><i class="fa fa-search"></i></button>
          </div>
        </th>
      </tr>
    </thead>
  </table>

  <div class="scrollDiv">
    <table class="table storeInfoTable table-hover mb-0">
      <colgroup>
      <col width="40%">
      <col width="20%">
      <col width="13%">
      <col width="30%">
    </colgroup>
    @for (item of facilityMerchandise; track item) {
      <tbody>
        <tr>
          <td>{{item.Name}}</td>
          <td>{{item.TenantPrice | currency}}</td>
          <td class="text-center">{{item.Quantity}}</td>
          <td></td>
        </tr>
      </tbody>
    }
  </table>
</div>
<!-- </div> -->
</div>
</div>
<div class="tab-pane fade" id="internet-unitInfo" role="tabpanel" aria-labelledby="internet-tab-unitInfo">
  <p>Website : <span style="color: blue; text-decoration: underline;cursor: pointer;"
  (click)="redirectToUrl()"> {{facilityInternetSettings?.WebsiteUrl}}</span></p>
  <p>Email : {{facilityInfoDetails?.EmailId}}</p>
  <!-- <a href="javascript:;">Site Info</a> -->
</div>
<div class="tab-pane fade" id="maps-unitInfo" role="tabpanel" aria-labelledby="maps-tab-unitInfo">
  <ul>
    <li>
      <label>From</label>
      <div class="inputbox"><input type="text" (focusin)="$event.stopPropagation()" class="form-control form-control-sm"
      [(ngModel)]="mapFrom" /></div>
    </li>
    <li>
      <label>To</label>
      <div class="inputbox"><input type="text" (focusin)="$event.stopPropagation()" class="form-control form-control-sm"
      [(ngModel)]="mapTo" /></div>
      <button type="button" class="btn btn-primary btn-sm" (click)="goToMap()"><i
      class="fa fa-search"></i></button>
    </li>
  </ul>
</div>
<div class="tab-pane fade" id="Siteinfo-unitInfo" role="tabpanel" aria-labelledby="Siteinfo-tab-unitInfo">
  <p class="m-0">{{facilityInternetSettings?.SiteInformation}}</p>
</div>
<div class="tab-pane fade" id="kiosk-unitInfo" role="tabpanel" aria-labelledby="kiosk-tab-unitInfo">
  <p class="m-0">{{facilityInternetSettings?.KioskInformation}}</p>
</div>
</div>
</div>
<div class="store_img"><img [src]="photoFilePath" style="height: 185px; width: 185px" alt="store image" /></div>
</div>
</div>
<div class="modal-footer">
</div>
</div>
</ng-template>


